// Converts grid filter values typed in the tenant's unit system into the
// stored unit the risk API compares in. Mirrors lib-map-components'
// useFilterModel.convertModel: a separate step over the filter items, a no-op
// for Metric tenants, with the target unit coming from column metadata.

export interface UnitFns {
	system: string; // 'Metric' | 'Imperial'
	getSystemUnit: (unit: string) => string | undefined;
	getStandardisedValue: (
		value: string,
		invalidValue?: string,
		standardUnit?: string,
	) => string;
}

const isBlank = (v: unknown) =>
	v === null || v === undefined || (typeof v === 'string' && v.trim() === '');

export function convertFilterItemsToStoredUnits<
	T extends { field: string; value?: unknown },
>(items: T[], unitsByField: Record<string, string>, units: UnitFns): T[] {
	if (units.system === 'Metric') return items;

	return items.map(item => {
		const unit = unitsByField[item.field];
		if (!unit || isBlank(item.value)) return item;
		const systemUnit = units.getSystemUnit(unit);
		if (!systemUnit) return item;

		const converted = units.getStandardisedValue(
			`${item.value}${systemUnit}`,
			'NaN',
			unit,
		);
		const n = Number(converted);
		// Drop on failure, unlike useFilterModel's keep-raw fallback: keeping the
		// raw value would send inches as mm and silently return the wrong pipes.
		if (!Number.isFinite(n)) return { ...item, value: undefined };
		// Round to 2 dp to strip float noise such as 304.79999999999995.
		return { ...item, value: String(Math.round(n * 100) / 100) };
	});
}
